"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processNotificationConfigurations = exports.getHttpNotificationData = exports.getEmailNotificationData = exports.fetchNotificationConfigurations = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var getEmailNotificationData = function getEmailNotificationData(state, props) {
  var newData = props.targets;
  var emailTarget = newData.find(function (target) {
    if (target.type === 'email') {
      target.label = state.label;
      target.config.endpoint = state.email;
      return true;
    }

    return false;
  });

  if (emailTarget === undefined) {
    var newTarget = {
      active: false,
      label: state.label,
      config: {
        endpoint: state.email,
        headers: {}
      },
      type: 'email'
    };
    newData === null || newData === void 0 ? void 0 : newData.push(newTarget);
  }

  return newData;
};

exports.getEmailNotificationData = getEmailNotificationData;

var getHttpNotificationData = function getHttpNotificationData(state, props) {
  var newData = props.targets;
  var webhookTarget = newData.find(function (target) {
    if (target.type === 'webhook') {
      target.label = state.label;
      target.config.endpoint = state.url;
      target.config.headers = state.rows.reduce(function (acc, row) {
        if (row.key !== '' && row.value !== '') acc[row.key] = row.value;
        return acc;
      }, {});
      return true;
    }

    return false;
  });

  if (webhookTarget === undefined) {
    var headers = state.rows.reduce(function (acc, row) {
      if (row.key !== '' && row.value !== '') acc[row.key] = row.value;
      return acc;
    }, {});
    var newTarget = {
      active: false,
      label: state.label,
      config: {
        endpoint: state.url,
        headers: headers
      },
      type: 'webhook'
    };
    newData.push(newTarget);
  }

  return newData;
};

exports.getHttpNotificationData = getHttpNotificationData;

var fetchNotificationConfigurations = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var response;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return _axios.default.get('/integration/bitoolsconnector/notificationConfiguration');

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            // eslint-disable-next-line no-console
            console.error(_context.t0);
            throw new Error('Unable to fetch data. Please try again later.');

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function fetchNotificationConfigurations() {
    return _ref.apply(this, arguments);
  };
}();

exports.fetchNotificationConfigurations = fetchNotificationConfigurations;

var processNotificationConfigurations = function processNotificationConfigurations(data, setRequestState) {
  if (!Array.isArray(data === null || data === void 0 ? void 0 : data.data)) {
    var _data$data, _data$data2;

    if ((data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.status) === 'IN_PROGRESS') {
      setRequestState({
        type: 'info',
        title: 'Saving in Progress...',
        message: 'Please wait a moment before trying to save again.'
      });
    }

    return data === null || data === void 0 ? void 0 : (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.targets;
  } else {
    return [];
  }
};

exports.processNotificationConfigurations = processNotificationConfigurations;